import { LocationSelectorService } from '@services/location_selector.service';
import { useService } from '@visiba/instantiation';
import { useEffect, useState } from 'react';
import { Config, ConfigService } from '@services/config.service';
import type { UnitNode } from '@services/unit.service';

export function useCurrentLocation(): [unit: UnitNode | null, config: Config | null] {
	const locationSelectorService = useService(LocationSelectorService);
	const configService = useService(ConfigService);
	const [locatedUnit, setLocatedUnit] = useState<UnitNode | null>(getInitialLocation());
	const [loadedConfig, setLoadedConfig] = useState<Config | null>(getInitialConfigValue());

	function getInitialConfigValue(): Config | null {
		try {
			return configService.getConfig(locationSelectorService.location.id);
		} catch {
			return null;
		}
	}

	function getInitialLocation(): UnitNode | null {
		try {
			return locationSelectorService.location;
		} catch {
			return null;
		}
	}

	useEffect(() => {
		function handleCommit(unitId: number): void {
			const unit = locationSelectorService.location;
			const config = configService.getConfig(unitId);

			// Don't know if React got a bug here but using the hook in multiple
			// places didn't work. The handler interrupted each other, don't really
			// know why.
			// thinking of ignoring setState and use a force updater instead...
			queueMicrotask(() => {
				setLocatedUnit(unit);
				setLoadedConfig(config);
			});
		}

		locationSelectorService.events.on('onCommitted', handleCommit);

		return () => {
			locationSelectorService.events.off('onCommitted', handleCommit);
		};
	}, [configService, locationSelectorService]);

	return [locatedUnit, loadedConfig];
}
